module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\"><path fill=\"#444\" d=\"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-29c7.18 0 13 5.82 13 13s-5.82 13-13 13S3 23.18 3 16 8.82 3 16 3zm.96 19.22c4.384-.866 7.786-2.86 9.015-5.52-.677 5.25-5.047 9.3-10.34 9.3-3.725 0-6.995-2.01-8.84-5.03 2.2 1.72 6.08 2.056 10.166 1.25zM20 11c0-1.657.895-3 2-3s2 1.343 2 3-.895 3-2 3-2-1.343-2-3zm-9 .61c-1.306 0-2.417.488-2.83 1.17C8.06 12.6 8 11.777 8 11.57c0-.97 1.343-1.758 3-1.758s3 .787 3 1.758c0 .206-.06 1.028-.17 1.21-.413-.682-1.523-1.17-2.83-1.17z\"/></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./icons/wink.svg
 ** module id = 18
 ** module chunks = 0
 **/